import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import { push } from 'redux-first-router';
import { format } from 'date-fns/fp';

import { gameUrl, gameDirectoryUrl } from '../../../lib/url-builders';

const query = gql`
  query UpcomingGameButton($gameType: GameType!, $search: GameSearchColumns) {
    game: nextUpcomingGame(type: $gameType, search: $search) {
      id
      type
      startDate
    }
  }
`;

const options = {
  options: ({ product: gameType, subtype }) => {
    const search = {
      startDate: `>=${format('y-MM-dd', new Date())}`,
    };

    if (subtype) search.subtype = subtype;

    return {
      variables: {
        gameType,
        search,
      },
      fetchPolicy: 'cache-first',
      errorPolicy: 'all',
      skip: !!gameType,
    };
  },
  props: ({ data: { game, loading }, ownProps: { navigating, product } }) => {
    const to = game
      ? gameUrl({ gameId: game.id, product: game.type })
      : gameDirectoryUrl({ product });

    if (navigating && game) {
      push(to);
    }

    return { loading, to, game };
  },
};

const withUpcomingGame = () => graphql(query, options);

export default withUpcomingGame;
